export const convertedDocumentLink = (link: string): string => {
    // Convert the link to a format suitable for the application
    // This function can be customized based on specific requirements
    // For example, removing special characters, converting to lowercase, etc.
    const SPECIAL_CHAR_REGEX = /[!&\/\\#,;+()$~%.'":*?<>{}]/g
    const SPACE_REGEX = /\s+/g
    const SPECIFIC_CHAR_REGEX = /®|–/g
    const CURLY_APOSTROPHE_REGEX = /’|/g

    let sanitizedLink = link.toLowerCase()
    sanitizedLink = sanitizedLink.replace(SPECIAL_CHAR_REGEX, '') // Remove special characters
    sanitizedLink = sanitizedLink.replace(SPACE_REGEX, '-') // Replace spaces with hyphens
    sanitizedLink = sanitizedLink.replace(SPECIFIC_CHAR_REGEX, '-') // Replace specific characters with hyphens
    sanitizedLink = sanitizedLink.replace(CURLY_APOSTROPHE_REGEX, '') // Remove curly apostrophes

    return sanitizedLink
}